module.exports = __webpack_public_path__ + "assets/boxicons.afbad0fa2cbbb785e034ae3e3bb328ff.eot";